import './style.css'
import { initAR } from './ar.ts'

initAR()
